const mediaHelper = require("styled-media-helper")

export const media = mediaHelper({
  sm: 320,
  md: 768,
  lg: 1240,
})
